//  import './_language.js';

window.addEventListener("load", function () {
    const btnBurger = document.querySelector('#ovensmash-26-pre-navigation .btn-burger');
    const btnCloseMenu = document.querySelector('#ovensmash-26-pre-navigation .btn_closeMenu');
    const dropdownMenu = document.querySelector('#ovensmash-26-pre-navigation .dropdown-menu');
    const languageInput = document.querySelector('#ovensmash-26-pre-navigation #language');
    const languageContainer = document.querySelector('#ovensmash-26-pre-navigation .language');
    const modalOverlay = document.querySelector('.modal-overlay');
    const html = document.documentElement;
    const menuLinks = document.querySelectorAll('#ovensmash-26-pre-navigation .dropdown-menu .list-items a');

    if (btnBurger && dropdownMenu) {
        btnBurger.addEventListener('click', function () {
            dropdownMenu.classList.add('active');
            if (modalOverlay) {
                modalOverlay.classList.add('hidden');
            }
            if (html) {
                html.classList.add('hidden');
            }
        });
    }

    const closeMenu = () => {
        dropdownMenu.classList.remove('active');
        if (modalOverlay) {
            modalOverlay.classList.remove('hidden');
        }
        if (html) {
            html.classList.remove('hidden');
        }
    };

    if (btnCloseMenu && dropdownMenu) {
        btnCloseMenu.addEventListener('click', function () {
            closeMenu();
        });
    }

    if (menuLinks && menuLinks.length) {
        menuLinks.forEach(link => {
            link.addEventListener('click', function () {
                closeMenu();
            });
        });
    }

    // Đóng language dropdown khi click ra ngoài trên PC
    if (languageInput && languageContainer) {
        // Ngăn click bên trong container bubble ra ngoài
        languageContainer.addEventListener('click', function(event) {
            event.stopPropagation();
        });

        // Đóng dropdown khi click ra ngoài
        document.addEventListener('click', function(event) {
            if (languageInput.checked) {
                languageInput.checked = false;
            }
        });
    }
});

